import React from "react";

import { T } from "services/lang/LanguageService";
import {
  IProductTemplateAttribute,
  Validation,
} from "components/dashboard/product-template-table/utils/interfaces";
import { InputSwitch, InputSwitchChangeEvent } from "primereact/inputswitch";
import { CellType } from "utils/enums";
import ValidationOptions from "./components/ValidationOptions";

type TimeTypeProps = {
  attribute: IProductTemplateAttribute;
  onChange: (e: InputSwitchChangeEvent) => void;
  onValidationChange: (validations: Validation[]) => void;
};

const TimeType: React.FC<TimeTypeProps> = ({ attribute, onChange, onValidationChange }) => {
  return (
    <>
      <div className="flex-1 flex w-full justify-content-start gap-3 p-3">
        <label htmlFor="autoFillTime">{T("word.auto-fill-time")}</label>
        <InputSwitch
          id="autoFillTime"
          checked={attribute.autoFillTime ?? false}
          onChange={onChange}
          name="autoFillTime"
          className="p-inputtext-sm"
        />
      </div>
      <ValidationOptions
        cellType={CellType.TIME}
        validators={attribute.validationOptions?.validators ?? []}
        onValidationChange={onValidationChange}
      />
    </>
  );
};

export default TimeType;
